export enum ErrorMessages {
  DeniedTransaction = 'Denied Transaction.',
  UserRejected = 'User rejected the request.',
  SignatureIsExpired = 'Signature is expired.',
  InsufficientBalance = 'Insufficient balance.',
  UnknownError = 'Something went wrong.',
  Required = 'This field is required.',
  InvalidAddressError = 'Invalid address error.',
  SignerIsNotOwner = 'Signer is not contract owner or publisher.',
  FailedSigner = 'Failed to recover signer.',
  InvalidType = 'Invalid value.',
  Min = 'Value must be at least [min].',
  Max = 'Value must be at most [max].',
  AmountError = 'Amount should not be greater than the balance ',
  NonZeroAmount = 'Amount must be greater than zero',
  MaxAmount = 'The entered value exceeds the available amount.',
  MaxSymbols = 'Maximum [max] symbols',
  MinSymbols = 'Minimum [min] symbols',
  UnexpectedSymbol = 'Unexpected symbol',
  ValueInRange = 'The values entered are incorrect. Please pay attention to the min and max values.',
  InvalidUrl = 'Invalid url.',
  MaxLengthExceeded = 'Url must be at most [max].',
  FarmAlreadyAdded = 'The farm is already added to the Dexfi protocol.',
  VoteExists = 'Vote exists.',
  FarmAdded = 'Farm added.',
  FarmBlacklisted = 'Farm is blacklisted.',
  IncorrectLink = 'Incorrect link.',
  PairNotExists = 'Processing failed: No farm data available for the specified pool.',
}

export enum SuccessMessages {
  Updated = 'Successfully updated',
  Voted = 'Successfully voted',
  Claimed = 'Successfully claimed',
  Harvested = 'Successfully harvested',
  Deposited = 'Successfully deposited',
  Minted = 'Successfully minted',
  Burned = 'Successfully burned',
  Bridged = 'Successfully bridged',
  Withdraw = 'Successfully withdraw',
  Bought = 'Successfully bought',
  Approved = 'Approved',
  Saved = 'Successfully saved',
  Created = 'Successfully created',
  UnSaved = 'Successfully unsaved',
  Archive = 'Successfully archived',
  UnArchive = 'Successfully unarchived',
  Deleted = 'Successfully deleted',
  Copied = 'Copied to clipboard. Use CTRL+V to share.',
  Published = 'Successfully published',
  Staked = 'Successfully staked',
  Unstaked = 'Successfully unstaked',
  Usdx_claimed = 'Successfully USDEX+ claimed',
}
